export const LOAD_FACILITY_HEADER_STARTED = "LOAD_FACILITY_HEADER_STARTED";
export const LOAD_FACILITY_HEADER_SUCCEEDED = "LOAD_FACILITY_HEADER_SUCCEEDED";
export const LOAD_FACILITY_HEADER_FAILED = "LOAD_FACILITY_HEADER_FAILED";

export const EXECUTE_FACILITY_REPORTS_STARTED = "EXECUTE_FACILITY_REPORTS_STARTED";
export const EXECUTE_FACILITY_REPORTS_SUCCEEDED = "EXECUTE_FACILITY_REPORTS_SUCCEEDED";
export const EXECUTE_FACILITY_REPORTS_FAILED = "EXECUTE_FACILITY_REPORTS_FAILED";

export const GENERATE_DOCUMENT_REPORT_STARTED = "GENERATE_DOCUMENT_REPORT_STARTED";
export const GENERATE_DOCUMENT_REPORT_SUCCEEDED = "GENERATE_DOCUMENT_REPORT_SUCCEEDED";
export const GENERATE_DOCUMENT_REPORT_FAILED = "GENERATE_DOCUMENT_REPORT_FAILED";

export const FACILITY_HEADER_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityHeaderInvalidated";
